export default {
    colorList: [
        {
            title: "纯色",
            list: [
                "白色-White",
                "黑色-black",
                "红色-red",
                "橙色-orange",
                "黄色-yellow",
                "绿色-green",
                "紫色-purple",
                "蓝色-blue",

                "青色-cyan",
                "灰色-grey",
                "金色-gold",
                "银色-Silver",
                "粉红色-Pink",
                "棕色-brown",

                "米色-Beige",
                "浅米色-Light beige",
                "透明-Transparent",
                "天蓝色-sky blue",
                "宝蓝色-Royal blue",
                "蓝色湖-Blue lake",
                "浅蓝-Light blue",
                "牛仔蓝-Denim Blue",

                "洗蓝色-Wash blue",
                "深棕色-Dark brown",
                "浅褐色-Light brown",
                "玫瑰金-Rose gold",
                "土豪金-Local gold",
                "军绿色-ArmyGreen",
                "深绿色-dark green",
                "淡绿色-Light green",
                "深灰色-Dark gray",
                "浅灰-Light gray",
                "玫瑰红-Rose red",
                "桃红-pink",
                "酒红色-Red wine",
                "荧光红-Fluorescent red",
                "淡粉色-Light pink",
                "荧光橙-Orange deep",
                "深紫色-purple",
                "轻卡其色-Light khaki",
                "咖啡-coffee",
                "深层皮肤-Deep skin",
                "紫丁香-lilac",
                "杏色-apricot",
                "肉色-Flesh",
                "品红色-magenta",
            ]
        },
        {
            title: "组合颜色",
            list: [
                "黑绿色-Black green",
                "白色黑色-White black",
                "白色蓝色-White Blue", 
                "灰棕色-Beige",
                "黑褐色-dark brown",
                "淡黄棕色-Light yellow brown", 
                "棕红色-maroon",
                "蓝绿-Blue green",
                "红绿-Red and green", 
                "黑灰色-dark grey",
                "蓝灰色-grey blue", 

                "银红-Silver red",
                "红黑-Red black",
                "银粉红色-Silver pink", 
                "白色粉红色-White pink",
                "银白色-silver white",

                "白红-White Red", 
                "灰色白色-grey White",
                "灰紫色-Gray-purple",

                "红黄色-Red yellow", 
                "银黄色-Silver yellow",
                "黄褐色-tan",
            ]
        }
    ],
}